















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import Breadcrumb from './Breadcrumb.vue';
/** 页面内部标题 */
@Component({ components: { Breadcrumb } })
export default class PageHeader extends Vue {
  title = '';
  @State(s => s.app.multiTab) multiTab?: boolean;

  @Watch('$route')
  routeChanged(val: any, old: any) {
    if (val.meta) {
      this.title = val.meta.title;
    }
  }
}
